



















































import Vue from 'vue'
import { mapActions, mapMutations, mapState } from 'vuex'
// moment
import moment from 'moment'
import 'moment/locale/it'

export default Vue.extend({
    computed: {
        ...mapState('reportMappa', ['statoSegnalazioni']),
        idSegnalazione: {
            get(): number {
                return this.$store.state.reportFiltriSegnalazione.idSegnalazione
            },
            set(value: number) {
                this.SET_ID_SEGNALAZIONE(value)
            }
        },
        statoSegnalazione: {
            get(): number {
                return this.$store.state.reportFiltriSegnalazione.statoSegnalazione
            },
            set(value: number) {
                this.SET_STATO_SEGNALAZIONE(value)
            }
        },
        tipoSegnalazione: {
            get(): number {
                return this.$store.state.reportFiltriSegnalazione.tipoSegnalazione
            },
            set(value: number) {
                this.SET_TIPO_SEGNALAZIONE(value)
            }
        },
        enteGestore: {
            get(): number {
                return this.$store.state.reportFiltriSegnalazione.enteGestore
            },
            set(value: number) {
                this.SET_ENTE_GESTORE(value)
            }
        },
        soloDaCro: {
            get(): boolean {
                return this.$store.state.reportFiltriSegnalazione.soloDaCro
            },
            set(value: boolean) {
                this.SET_SOLO_DA_CRO(value)
            }
        },
        dataUltimaSegnalazioneParsata(): string {
            // leggiamo la data
            moment.locale('it')
            return moment(this.statoSegnalazioni.data_ultima_segnalazione).format('DD MMMM YYYY')
        }
    },
    methods: {
        ...mapActions('modal', ['showModal']),
        ...mapActions('reportFiltriSegnalazione', ['resettaFiltri']),
        ...mapMutations('reportFiltriSegnalazione', ['SET_ID_SEGNALAZIONE', 'SET_STATO_SEGNALAZIONE',
            'SET_TIPO_SEGNALAZIONE', 'SET_SOLO_DA_CRO', 'SET_ENTE_GESTORE'])
    }
})
